import type { TenantConfig } from '@/types/TenantConfig'

export const wndr: TenantConfig = {
  themeMode: 'dark',
  themeOptions: {
    dialog: {
      headerBackground: '#1F1F1F',
      backgroundColor: '#000000',
    },
    mobileFooter: {
      backgroundColor: '#1F1F1F',
      cartButtonBackgroundColor: 'transparent',
      cartButtonHoverBackgroundColor: 'transparent',
      cartButtonBorder: '1px solid #ffffff',
    },
    backButton: {
      backgroundColor: '#ffffff',
      iconColor: '#000000',
    },
    datePicker: {
      selectedDayTextColor: '#000000',
    },
  },
  logo: 'assets/wndr/static/logo.svg',
  teaserImageSize: {
    height: 208,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/wndr/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/wndr/static/fonts.css',
    },
  },
}
